import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FaqSection() {
  const faqs = [{
    q: 'Ab wann hat Laura eine Verbesserung bemerkt?',
    a: 'Bereits nach 7–10 Tagen zeigte Milo deutliche Verbesserungen. Bei manchen Hunden dauert es etwas länger — bis zu 3 Wochen.'
  }, {
    q: 'Ist das Topping auch für empfindliche Hunde geeignet?',
    a: 'Ja — das Topping enthält keine Zusatzstoffe, keine künstlichen Aromen und ist speziell für Hunde mit empfindlichem Magen entwickelt.'
  }, {
    q: 'Wie viel gibt man täglich?',
    a: 'Die empfohlene Menge steht auf der Verpackung und richtet sich nach dem Körpergewicht des Hundes. Laura hat mit der kleinsten Menge angefangen und langsam gesteigert.'
  }, {
    q: 'Was wenn es bei meinem Hund nicht wirkt?',
    a: 'Hunderunde bietet eine Zufriedenheitsgarantie. Falls du keine Verbesserung siehst, kannst du dich direkt an den Kundenservice wenden.'
  }];
  return <section className="py-16 bg-cream" data-id="element-85">
      <div className="max-w-3xl mx-auto px-4" data-id="element-86">
        <h2 className="font-handwritten text-4xl text-center text-forestGreen mb-10" data-id="element-87">
          Häufige Fragen
        </h2>

        <div className="space-y-4" data-id="element-88">
          {faqs.map((faq, idx) => <FaqItem key={idx} question={faq.q} answer={faq.a} data-id="element-89" />)}
        </div>
      </div>
    </section>;
}
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-white rounded-lg shadow-sm border border-warmBrown/10 overflow-hidden" data-id="element-90">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-91">
        <span className="font-serif font-bold text-forestGreen text-lg" data-id="element-92">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-warmBrown transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-93" />
      </button>
      <AnimatePresence data-id="element-94">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-95">
            <div className="px-6 pb-4 font-serif text-gray-700 leading-relaxed border-t border-gray-100 pt-3" data-id="element-96">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}